module.exports = __webpack_public_path__ + "img/v3-briefcase.d72252c0.svg";